import { render, staticRenderFns } from "./Screen5.vue?vue&type=template&id=ba99530e&scoped=true&lang=html&"
import script from "./Screen5.vue?vue&type=script&lang=js&"
export * from "./Screen5.vue?vue&type=script&lang=js&"
import style0 from "./Screen5.vue?vue&type=style&index=0&id=ba99530e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba99530e",
  null
  
)

export default component.exports